export const BASE_URL = process.env.REACT_APP_BASE_URL
export const BASE_URL_VIEW = process.env.REACT_APP_BASE_URL_VIEW
export const BASE_URL_CDN = process.env.REACT_APP_BASE_URL_CDN
export const DEFAULT_AVATAR = process.env.REACT_APP_DEFAULT_AVATAR

const normalizeSignalRBaseUrl = (url?: string | null) => {
  if (!url) {
    return undefined
  }

  return url.replace(/\/$/, '').replace(/\/poolvn-api$/, '')
}

export const SIGNALR_BASE_URL = normalizeSignalRBaseUrl(process.env.REACT_APP_SIGNALR_BASE_URL || BASE_URL)
export const TOURNAMENT_BANK_BIN = process.env.REACT_APP_TOURNAMENT_BANK_BIN || '970422'
export const TOURNAMENT_ACCOUNT_NUMBER = process.env.REACT_APP_TOURNAMENT_ACCOUNT_NUMBER || '0923459456'
export const DONATE_BANK_BIN = process.env.REACT_APP_DONATE_BANK_BIN || '970422'
export const DONATE_ACCOUNT_NUMBER = process.env.REACT_APP_DONATE_ACCOUNT_NUMBER || '6866667888888'

export const EDIT_TOURNAMENT_KEY_IN_LINK = 'edit-tournament'

export * from './PlayerReportStatus'

export const ACCOUNT = {
  ACTION_TYPES: {
    REGISTER: 'ACCOUNT/REGISTER',
    LOGIN: 'ACCOUNT/LOGIN',
    GET_ACCOUNT_INFO: 'ACCOUNT/GET_ACCOUNT_INFO',
    GET_ACCOUNTS: 'ACCOUNT/GET_ACCOUNTS',
    REFETCH_TOKEN: 'ACCOUNT/REFETCH_TOKEN',
    LOGOUT: 'ACCOUNT/LOGOUT'
  },
  URL_API: {
    REGISTER_API: `${BASE_URL}/api/account/register`,
    LOGIN_API: `${BASE_URL}/api/account/login`,
    LOGIN_GOOGLE_API: `${BASE_URL}/api/account/login-google`,
    GET_ACCOUNT_INFO_API: `${BASE_URL}/api/account/accountinfo`,
    REFETCH_TOKEN_API: `${BASE_URL}/api/account/refetch-token`,
    CHANGE_PASSWORD_API: `${BASE_URL}/api/account/change-password`,
    RESET_PASSWORD_API: `${BASE_URL}/api/account/reset-password`,
    LOGOUT_API: `${BASE_URL}/api/account/logout`,
    VERIFY_EMAIL_API: `${BASE_URL}/api/account/verify-email`,
    RESEND_VERIFY_CODE_API: `${BASE_URL}/api/account/resend-verify-code`,
    FORGOT_PASSWORD_API: `${BASE_URL}/api/account/forgot-password`,
    RESET_PASSWORD_WITH_CODE_API: `${BASE_URL}/api/account/reset-password-with-code`,
    CREATE_ACCOUNT_API: `${BASE_URL}/api/account/create-account`,
    GET_ACCOUNTS_API: `${BASE_URL}/api/account/get-accounts`,
    TOGGLE_ACCOUNT_STATUS_API: `${BASE_URL}/api/account/toggle-status`,
    UPDATE_ACCOUNT_API: `${BASE_URL}/api/account/update-account`,
    APPROVE_PROFILE_API: `${BASE_URL}/api/account/approve-profile`,
    REQUEST_PROFILE_UPDATE_API: `${BASE_URL}/api/account/request-profile-update`,
    UPDATE_BANK_API: `${BASE_URL}/api/account/update-bank`
  }
}

export const ROLE = {
  ACTION_TYPES: {
    GET_CBX: 'ROLE/GET_CBX'
  },
  URL_API: {
    GET_CBX_API: `${BASE_URL}/api/role/get-cbx`
  }
}

export const USER = {
  ACTION_TYPES: {
    CREATE: 'USER/CREATE',
    GET_BY_ID: 'USER/GET_BY_ID',
    UPDATE: 'USER/UPDATE',
    GET_RANKING: 'USER/GET_RANKING',
    GET_NOT_JOINED_RANKING: 'USER/GET_NOT_JOINED_RANKING'
  },
  URL_API: {
    CREATE_API: `${BASE_URL}/api/user/create`,
    GET_BY_ID_API: `${BASE_URL}/api/user/get-by-id`,
    UPDATE_API: `${BASE_URL}/api/user/update`,
    GET_RANKING_API: `${BASE_URL}/api/user/ranking`,
    GET_NOT_JOINED_RANKING_API: `${BASE_URL}/api/user/not-joined-ranking`
  }
}

export const CLUB = {
  ACTION_TYPES: {
    CREATE: 'CLUB/CREATE',
    GET_BY_ID: 'CLUB/GET_BY_ID',
    GET_PAGING: 'CLUB/GET_PAGING',
    UPDATE: 'CLUB/UPDATE'
  },
  URL_API: {
    CREATE_API: `${BASE_URL}/api/club/create`,
    GET_BY_ID_API: `${BASE_URL}/api/club/get-by-id`,
    GET_PAGING_API: `${BASE_URL}/api/club/paging`,
    UPDATE_API: `${BASE_URL}/api/club/update`,
    GENERATE_SEPAY_SECRET_API: `${BASE_URL}/api/club/generate-sepay-secret`,
    GET_TRANSACTION_HISTORY_API: `${BASE_URL}/api/club/transaction-history`
  }
}

export const BANK = {
  URL_API: {
    GET_ALL_API: `${BASE_URL}/api/bank/all`
  }
}


export const TABLE = {
  ACTION_TYPES: {
    GET_BY_CLUB: 'TABLE/GET_BY_CLUB',
    ADD: 'TABLE/ADD',
    EDIT: 'TABLE/EDIT',
    DELETE: 'TABLE/DELETE',
    GET_TABLE_TEMPLATE: 'TABLE/GET_TABLE_TEMPLATE',
    IMPORT_TABLE: 'TABLE/IMPORT_TABLE'
  },
  URL_API: {
    GET_BY_CLUB_API: `${BASE_URL}/api/table/get-by-club`,
    ADD_API: `${BASE_URL}/api/table/add`,
    EDIT_API: `${BASE_URL}/api/table/edit`,
    DELETE_API: `${BASE_URL}/api/table/delete`,
    GET_TABLE_TEMPLATE_API: `${BASE_URL}/api/table/table-template`,
    IMPORT_TABLE_API: `${BASE_URL}/api/table/import-table`
  }
}

export const TOURNAMENT = {
  ACTION_TYPES: {
    GET_BY_ID: 'TOURNAMENT/GET_BY_ID',
    GET_BY_CLUB_ID: 'TOURNAMENT/GET_BY_CLUB_ID',
    CREATE_STEP_ONE: 'TOURNAMENT/CREATE_STEP_ONE',
    CREATE_STEP_TWO: 'TOURNAMENT/CREATE_STEP_TWO',
    CREATE_STEP_THREE: 'TOURNAMENT/CREATE_STEP_THREE',
    CREATE_STEP_FOUR: 'TOURNAMENT/CREATE_STEP_FOUR',
    GET_STATISTIC: 'TOURNAMENT/GET_STATISTIC',
    GET_PAGING: 'TOURNAMENT/GET_PAGING',
    RESPONSE_JOIN_REQUEST: 'TOURNAMENT/RESPONSE_JOIN_REQUEST',
    TABLE_SETTINGS: 'TOURNAMENT/TABLE_SETTINGS',
    UPDATE_BRACKET_SIZE: 'TOURNAMENT/UPDATE_BRACKET_SIZE',
    START: 'TOURNAMENT/START',
    GENERATE_FAKE_DATA: 'TOURNAMENT/GENERATE_FAKE_DATA',
    GET_ADMIN_PAGING: 'TOURNAMENT/GET_ADMIN_PAGING',
    REVIEW: 'TOURNAMENT/REVIEW',
    GET_TABLES: 'TOURNAMENT/GET_TABLES'
  },
  URL_API: {
    GET_BY_ID_API: `${BASE_URL}/api/tournament/get-by-id`,
    GET_BY_CLUB_ID_API: `${BASE_URL}/api/tournament/get-by-club`,
    CREATE_STEP_ONE_API: `${BASE_URL}/api/tournament/create-step-one`,
    CREATE_STEP_TWO_API: `${BASE_URL}/api/tournament/create-step-two`,
    CREATE_STEP_THREE_API: `${BASE_URL}/api/tournament/create-step-three`,
    CREATE_STEP_FOUR_API: `${BASE_URL}/api/tournament/create-step-four`,
    GET_STATISTIC_API: `${BASE_URL}/api/tournament/get-statistic`,
    GET_PAGING_API: `${BASE_URL}/api/tournament/paging`,
    RESPONSE_JOIN_REQUEST_API: `${BASE_URL}/api/tournament/response-join-request`,
    TABLE_SETTINGS_API: `${BASE_URL}/api/tournament/table-settings`,
    UPDATE_BRACKET_SIZE_API: `${BASE_URL}/api/tournament/update-bracket-size`,
    START_API: `${BASE_URL}/api/tournament/start`,
    GENERATE_FAKE_DATA_API: `${BASE_URL}/api/tournament/fakedata`,
    GET_ADMIN_PAGING_API: `${BASE_URL}/api/tournament/admin-paging`,
    REVIEW_API: `${BASE_URL}/api/tournament/review`,
    GET_ADMIN_REVENUE_API: `${BASE_URL}/api/tournament/revenue`,
    GET_CLUB_PAYMENT_HISTORY_API: `${BASE_URL}/api/tournament/club-payment-history`,
    MARK_AS_PAID_API: `${BASE_URL}/api/tournament/mark-as-paid`,
    APPROVE_SETTLEMENT_API: `${BASE_URL}/api/tournament/approve-settlement`,
    UPDATE_COMMISSION_RATE_API: `${BASE_URL}/api/tournament/update-commission-rate`,
    GET_TABLES_API: `${BASE_URL}/api/tournament/get-tables`,
    UPDATE_VIRTUAL_PLAYER_API: `${BASE_URL}/api/tournament/update-virtual-player`
  }
}

export const PROVINCE = {
  ACTION_TYPES: {
    GET_CBX: 'CLUB/GET_CBX'
  },
  URL_API: {
    GET_CBX_API: `${BASE_URL}/api/province/get-cbx`
  }
}

export const DISTRICT = {
  ACTION_TYPES: {
    GET_CBX: 'CLUB/GET_CBX'
  },
  URL_API: {
    GET_CBX_API: `${BASE_URL}/api/district/get-cbx`
  }
}

export const WARD = {
  ACTION_TYPES: {
    GET_CBX: 'CLUB/GET_CBX'
  },
  URL_API: {
    GET_CBX_API: `${BASE_URL}/api/ward/get-cbx`
  }
}

export const PLAYER = {
  ACTION_TYPES: {
    GET_BY_TOURNAMENT: 'PLAYER/GET_BY_TOURNAMENT',
    UPDATE_FOR_TOURNAMNET: 'PLAYER/UPDATE_FOR_TOURNAMNET',
    JOIN_REQUEST: 'PLAYER/JOIN_REQUEST',
    CANCEL_JOIN_REQUEST: 'PLAYER/CANCEL_JOIN_REQUEST',
    GET_OVERVIEW: 'PLAYER/GET_OVERVIEW',
    GET_STATISTICS: 'PLAYER/GET_STATISTICS',
    REFRESH_PAYMENT_CODE: 'PLAYER/REFRESH_PAYMENT_CODE',
    GET_PAYMENT_STATUS: 'PLAYER/GET_PAYMENT_STATUS'
  },
  URL_API: {
    GET_BY_TOURNAMENT_API: `${BASE_URL}/api/player/get-by-tournament`,
    UPDATE_FOR_TOURNAMNET_API: `${BASE_URL}/api/player/update-tournament`,
    JOIN_REQUEST_API: `${BASE_URL}/api/player/join-request`,
    CANCEL_JOIN_REQUEST_API: `${BASE_URL}/api/player/cancel-join`,
    GET_OVERVIEW_API: `${BASE_URL}/api/player/get-overview`,
    GET_STATISTICS_API: `${BASE_URL}/api/player/get-statistics`,
    REFRESH_PAYMENT_CODE_API: `${BASE_URL}/api/player/refresh-payment-code`,
    GET_PAYMENT_STATUS_API: `${BASE_URL}/api/player`,
    UPDATE_CHECK_IN_API: `${BASE_URL}/api/player/update-check-in`
  }
}

export const MATCH = {
  ACTION_TYPES: {
    INIT_BRACKET: 'MATCH/INIT_BRACKET',
    GET_BY_TOUR: 'MATCH/GET_BY_TOUR',
    START: 'MATCH/START',
    GET_BY_ID: 'MATCH/GET_BY_ID',
    UPDATE: 'MATCH/UPDATE',
    CANCEL_RESULT: 'MATCH/CANCEL_RESULT',
    GET_NEXT_MATCHES: 'MATCH/GET_NEXT_MATCHES'
  },
  URL_API: {
    INIT_BRACKET_API: `${BASE_URL}/api/match/init-bracket`,
    GET_BY_TOUR_API: `${BASE_URL}/api/match/get-by-tour`,
    START_API: `${BASE_URL}/api/match/start`,
    GET_BY_ID_API: `${BASE_URL}/api/match/get-by-id`,
    UPDATE_API: `${BASE_URL}/api/match/update`,
    CANCEL_RESULT_API: `${BASE_URL}/api/match/cancel-result`,
    GET_NEXT_MATCHES_API: `${BASE_URL}/api/match/get-next-matches`,
    GET_ANNOUNCEMENT_AUDIO_API: `${BASE_URL}/api/match/get-announcement-audio`,
    SWAP_ROUND1_PLAYERS_API: `${BASE_URL}/api/match/swap-round1-players`,
    SWAP_ROUND1_MATCHES_API: `${BASE_URL}/api/match/swap-round1-matches`
  }
}

export const DONATION = {
  ACTION_TYPES: {
    CREATE: 'DONATION/CREATE',
    LIST: 'DONATION/LIST'
  },
  URL_API: {
    CREATE_API: `${BASE_URL}/api/donation/create`,
    LIST_API: `${BASE_URL}/api/donation/list`,
    CHECK_API: `${BASE_URL}/api/donation/check`
  },
  HUB: SIGNALR_BASE_URL ? `${SIGNALR_BASE_URL}/hub/donation` : undefined,
  EVENTS: {
    RECEIVE_DONATION: 'ReceiveDonation',
    DONATION_COMPLETED: 'DonationCompleted'
  }
}

export const MATCH_PREDICTION = {
  ACTION_TYPES: {
    CREATE: 'MATCH_PREDICTION/CREATE',
    GET_BY_MATCH: 'MATCH_PREDICTION/GET_BY_MATCH',
    GET_LATEST_BY_MATCH: 'MATCH_PREDICTION/GET_LATEST_BY_MATCH',
    GET_LEADERBOARD: 'MATCH_PREDICTION/GET_LEADERBOARD',
    GET_BY_TOURNAMENT: 'MATCH_PREDICTION/GET_BY_TOURNAMENT',
    RECALCULATE_SCORES: 'MATCH_PREDICTION/RECALCULATE_SCORES'
  },
  URL_API: {
    CREATE_API: `${BASE_URL}/api/matchprediction/predict`,
    GET_BY_MATCH_API: `${BASE_URL}/api/matchprediction/match`,
    GET_LATEST_BY_MATCH_API: `${BASE_URL}/api/matchprediction/match`,
    GET_LEADERBOARD_API: `${BASE_URL}/api/matchprediction/tournament`,
    GET_BY_TOURNAMENT_API: `${BASE_URL}/api/matchprediction/tournament`,
    RECALCULATE_SCORES_API: `${BASE_URL}/api/matchprediction/tournament`
  }
}

export const HOME = {
  URL_API: {
    VIEW_API: `${BASE_URL}/api/home/view`
  }
}

export const REPORT = {
  ACTION_TYPES: {
    SUBMIT: 'REPORT/SUBMIT',
    APPROVE: 'REPORT/APPROVE',
    REJECT: 'REPORT/REJECT',
    APPEAL: 'REPORT/APPEAL',
    FINALIZE: 'REPORT/FINALIZE',
    GET_PENDING: 'REPORT/GET_PENDING',
    GET_FINALIZE_PENDING: 'REPORT/GET_FINALIZE_PENDING',
    GET_SENT: 'REPORT/GET_SENT',
    GET_RECEIVED: 'REPORT/GET_RECEIVED',
    GET_REPORT_TYPES: 'REPORT/GET_REPORT_TYPES',
    GET_COMPLETED: 'REPORT/GET_COMPLETED',
    GET_COUNTS: 'REPORT/GET_COUNTS'
  },
  URL_API: {
    URL_API: `${BASE_URL}/api/report`,
    SUBMIT_API: `${BASE_URL}/api/report/submit`,
    APPROVE_API: `${BASE_URL}/api/report/approve`,
    REJECT_API: `${BASE_URL}/api/report/reject`,
    APPEAL_API: `${BASE_URL}/api/report/appeal`,
    FINALIZE_API: `${BASE_URL}/api/report/finalize`,
    GET_PENDING_API: `${BASE_URL}/api/report/pending`,
    GET_FINALIZE_PENDING_API: `${BASE_URL}/api/report/to-finalize`,
    GET_COMPLETED_API: `${BASE_URL}/api/report/completed`,
    GET_COUNTS_API: `${BASE_URL}/api/report/counts`,
    GET_REPORT_TYPES_API: `${BASE_URL}/api/masterrule`
  }
}

export const ACCRUED_POINTS = {
  ACTION_TYPES: {
    GET_LEADERBOARD: 'ACCRUED_POINTS/GET_LEADERBOARD',
    ADJUST: 'ACCRUED_POINTS/ADJUST'
  },
  URL_API: {
    GET_LEADERBOARD_API: `${BASE_URL}/api/accruedpoints/leaderboard`,
    ADJUST_POINTS_API: `${BASE_URL}/api/accruedpoints/adjust`
  }
}

export const MONTHLY_REWARD = {
  ACTION_TYPES: {
    GET_ALL: 'MONTHLY_REWARD/GET_ALL',
    CREATE: 'MONTHLY_REWARD/CREATE',
    UPDATE: 'MONTHLY_REWARD/UPDATE',
    DELETE: 'MONTHLY_REWARD/DELETE'
  },
  URL_API: {
    BASE_API: `${BASE_URL}/api/monthlyreward`
  }
}

export const REWARD = {
  ACTION_TYPES: {
    GET_POINT_HISTORY: 'REWARD/GET_POINT_HISTORY',
    GET_MONTHLY_REWARDS: 'REWARD/GET_MONTHLY_REWARDS'
  },
  URL_API: {
    GET_POINT_HISTORY_API: `${BASE_URL}/api/reward/history`,
    GET_MONTHLY_REWARDS_API: `${BASE_URL}/api/monthlyreward`
  }
}

export const QUICK_RESPONSE = {
  ACTION_TYPES: {
    GET_ALL: 'QUICK_RESPONSE/GET_ALL',
    GET_BY_USAGE: 'QUICK_RESPONSE/GET_BY_USAGE',
    CREATE: 'QUICK_RESPONSE/CREATE',
    UPDATE: 'QUICK_RESPONSE/UPDATE',
    DELETE: 'QUICK_RESPONSE/DELETE'
  },
  URL_API: {
    BASE_API: `${BASE_URL}/api/quick-response`
  }
}

export const RULE = {
  ACTION_TYPES: {
    GET_ALL: 'RULE/GET_ALL',
    ADD: 'RULE/ADD',
    UPDATE: 'RULE/UPDATE',
    DELETE: 'RULE/DELETE'
  },
  URL_API: {
    BASE_API: `${BASE_URL}/api/masterrule`,
    GET_ALL_API: `${BASE_URL}/api/masterrule`,
    ADD_API: `${BASE_URL}/api/masterrule`,
    UPDATE_API: `${BASE_URL}/api/masterrule`,
    DELETE_API: `${BASE_URL}/api/masterrule`
  }
}

export const SYSTEM = {
  URL_API: {
    SETTINGS_API: `${BASE_URL}/api/masterdata/status`,
    CACHE_STATUS_API: `${BASE_URL}/api/masterdata/cache-status`,
    CACHE_TOGGLE_API: `${BASE_URL}/api/masterdata/cache-toggle`,
    LIMIT_DRAFT_TOGGLE_API: `${BASE_URL}/api/masterdata/limit-draft-toggle`,
    AUDIO_ANNOUNCEMENT_TOGGLE_API: `${BASE_URL}/api/masterdata/audio-announcement-toggle`,
    GENERATE_BASE_AUDIO_API: `${BASE_URL}/api/masterdata/generate-base-audio`,
    UPDATE_BASE_TOURNAMENT_FEE_API: `${BASE_URL}/api/masterdata/base-tournament-fee`,
    AUTO_APPROVE_TOGGLE_API: `${BASE_URL}/api/masterdata/auto-approve-toggle`
  }
}

export const TRANSACTION = {
  URL_API: {
    GET_HISTORY_API: `${BASE_URL}/api/transaction/history`,
    CREATE_PAYMENT_API: `${BASE_URL}/api/transaction/create-payment`,
    RECALCULATE_BALANCE_API: `${BASE_URL}/api/transaction/recalculate-balance`
  }
}

export const TRANSACTION_COUNTERPARTY_TYPE = {
  USER: 1,
  CLUB: 2,
  INVESTOR: 3,
  OTHER: 4
}

export const NOTIFICATION = {
  ACTION_TYPES: {
    GET_SUMMARY: 'NOTIFICATION/GET_SUMMARY'
  },
  URL_API: {
    GET_SUMMARY_API: `${BASE_URL}/api/notification/summary`
  }
}

export const ACCOUNT_HUB = {
  HUB_URL: SIGNALR_BASE_URL ? `${SIGNALR_BASE_URL}/hub/account` : undefined,
  EVENTS: {
    CLUB_DEPOSIT_SUCCESS: 'ClubDepositSuccess'
  }
}
